import { createStore, sample } from 'effector'
import { not } from 'patronum'
import {
  $isFetchEpgInfoFxPending,
  fetchEpg,
} from '~/entities/epg/programs/model'
import { F, T } from '~/shared/helpers'
import {
  loadMoreAllFx,
  loadMoreByCategoryFx,
  loadMoreFavoritesFx,
} from './model'

// Skeletons while loading more channels
export const $isLoadingMoreChannelsAndPrograms = createStore(false) // for channel page with epg
export const $isLoadingMoreChannels = createStore(false) // for live module with grid

// show skeleton when channels are loading
sample({
  clock: [loadMoreFavoritesFx, loadMoreByCategoryFx, loadMoreAllFx],
  fn: T,
  target: [$isLoadingMoreChannelsAndPrograms, $isLoadingMoreChannels],
})

// hide skeleton when epg is loaded or channels load failed
sample({
  clock: [
    // EPG request may be skipped if channels are already in grid
    // Example: When switching categories, if channels were previously loaded (for example in All category),
    // their EPG data may already be cached and no new request is needed
    // For this case me need to hide skeleton at fetchEpg clock event
    fetchEpg,
    $isFetchEpgInfoFxPending,
    // Can't use .finally here since after successfully loading more channels we need to wait for EPG data to load.
    // However, we should hide the skeleton if loading more channels fails.
    loadMoreFavoritesFx.fail,
    loadMoreByCategoryFx.fail,
    loadMoreAllFx.fail,
  ],
  filter: not($isFetchEpgInfoFxPending),
  fn: F,
  target: $isLoadingMoreChannelsAndPrograms,
})

// hide skeleton when channels are loaded
sample({
  clock: [
    loadMoreFavoritesFx.finally,
    loadMoreByCategoryFx.finally,
    loadMoreAllFx.finally,
  ],
  fn: F,
  target: $isLoadingMoreChannels,
})
